export function initRoHrTranslation() {

    $("html").attr("lang", "hr");

    function able_trans_header() {
        $('#navigation-first > a > span').html((i, t) => t.replace("Acasă", "Dom"));
        $('#header .cart-count .cart-price').html((i, t) => t && t.replace("Coş gol", "Prazna košara"));

        $('.top-navigation-bar .top-nav-button-login').html((i, t) => t.replace("Autentificare", "Prijaviti se"));
        $('.top-navigation-bar .top-nav-button-logout').html((i, t) => t.replace("Logout", "Odjavite se"));
        $('.top-navigation-bar .top-nav-button-account').html((i, t) => t.replace("My account", "Moj račun"));
        $("#header #formSearchForm .form-control").attr("placeholder", "Napiši što tražiš");
        $('#header #formSearchForm button.btn').html((i, t) => t.replace("Căutare termen", "Traži"));
        $('#formSearchForm button.btn').html((i, t) => t && t.replace("Căutare", "Pretraga"));
        $('.header-bottom .menu-helper > span, .menu-helper > span').html((i, t) => t && t.replace("Mai mult", "Više"));
        $('.cart-count .cart-price').html((i, t) => t && t.replace("Coş de cumpărături", "Košarica"));
        $('.language-switcher, .language, .top-navigation-bar .language, .language-menu').html((i, t) => t && t.replace("Limba", "Jezik").replace("Română", "Rumunjski"));
        $('a.skip-to-content, .skip-link, a[href="#content"]').html((i, t) => t && t.replace("Treci la conținut", "Prijeđi na sadržaj"));
        $('a:contains("Autentificare")').html((i, t) => t && t.replace("Autentificare", "Prijava"));
        $('a:contains("Înregistrare")').html((i, t) => t && t.replace("Înregistrare", "Registracija"));
        $('#formSearchForm .form-control, #formSearchForm input[type="search"], #formSearchForm input[type="text"]').attr("placeholder", "Napiši što tražiš");
        $('.search, #header').find('label, .search-title, .search-text').html((i, t) => t && t.replace("Căutare", "Pretraga"));

        document.addEventListener('ShoptetDOMSearchResultsLoaded', () => {
            $('.searchWhisperer__content--empty').html((i, t) => t && t.replace("Nu s-au găsit rezultate.", "Nema rezultata."));
            $('.searchWhisperer__products__heading').text(function (_i, t) {
                return t.replace("Găsit în produse", "Pronađeno u proizvodima");
            });
            $('.searchWhisperer__additionalResults__heading--category').text(function (_i, t) {
                return t.replace("Găsit în categorii", "Pronađeno u kategorijama");
            });
            $('.searchWhisperer__additionalResults__heading--brand').text(function (_i, t) {
                return t.replace("Găsit în mărci", "Pronađeno u markama");
            });
            $('.searchWhisperer__additionalResults__heading--article').text(function (_i, t) {
                return t.replace("Găsit în articole", "Pronađeno u člancima");
            });
            $('.searchWhisperer__buttonWrapper [data-testid="btnShowAllResults"]').text(function (_i, t) {
                return t.replace("Afişează toate rezultatele", "Prikaži sve rezultate");
            });
        })

        $('#header .header-bottom .menu-helper > span').html((i, t) => t.replace("More", "Više"));
        $('.login-widget h2').html((i, t) => t && t.replace("Autentificare în contul dumneavoastră", "Prijavite se na svoj račun"));
        $('.login-widget div.email input[name="email"]').attr("placeholder", "Email adresa");
        $('.login-widget div.password input[name="password"]').attr("placeholder", "Lozinka");
        $('.login-widget .no-display').html((i, t) => t && t.replace("Nu puteţi completa acest câmp", "Ne možete ispuniti ovo polje"));
        $('.login-widget button.btn-login').html((i, t) => t.replace("Autentificare", "Prijaviti se"));
        $('.login-widget a[href="/inregistrare/"]').html((i, t) => t && t.replace("Registracija nouă", "Registracija"));
        $('.login-widget a[href="/centru-clienti/resetati-parola/"]').html((i, t) => t && t.replace("Parola uitată?", "Zaboravljena lozinka"));
        $('.login-widget .login-btn.facebook strong').html((i, t) => t && t.replace("Autentificare cu Facebook", "Prijavite se putem Facebooka"));
        $('.login-widget .login-btn.google strong').html((i, t) => t && t.replace("Autentificare cu Google", "Prijavite se s Googleom"));
        $('.login-widget .login-btn.seznam strong').html((i, t) => t && t.replace("Conectați-vă prin Seznam", "Prijava preko Seznam"));
        $('.login-widget .social-login-buttons-divider span').html((i, t) => t && t.replace("sau", "ili"));

        $('.main-navigation, #navigation, nav, .header-bottom, .menu, .submenu, .navigation').html((i, t) => t && t
            .replace("BRANDS", "Brendovi")
            .replace("MODELS ACCESSORIES", "Dodaci za modele")
            .replace("ACCESSORIES", "Dodatna oprema")
            .replace("CLOTHING", "Odjeća")
            .replace("LIFE JACKETS", "Prsluci za spašavanje")
            .replace("PARTS", "Dijelovi")
            .replace("WATER FUN", "Zabava na vodi")
            .replace("COVERS", "Navlake i pokrovi")
            .replace("ALL MODELS", "Svi modeli")
            .replace("RECREATION", "Rekreacija")
            .replace("PERFORMANCE", "Performanse")
            .replace("TOURING", "Putovanja")
            .replace("TOW SPORTS", "Vučni sportovi")
            .replace("SPORT FISHING", "Sportski ribolov")
            .replace("MEN", "Muškarci")
            .replace("WOMEN", "Žene")
            .replace("YOUTH", "Djeca")
            .replace("Trailers Accessories", "Oprema za prikolice")
            .replace("Storage", "Pohrana")
            .replace("Coolers", "Hladnjaci")
            .replace("Fuel Caddies", "Kanistri za gorivo")
            .replace("Racks, Holders & Installation Kits", "Nosači i instalacijski setovi")
            .replace("Docking & Anchoring", "Privezi i sidrenje")
            .replace("Audio & Electronic", "Audio i elektronika")
            .replace("Body Accessories", "Karoserijski dodaci")
            .replace("Steering, Control & Acceleration", "Upravljanje i ubrzanje")
            .replace("Safety & Mandatory Regulations", "Sigurnosna i obvezna oprema")
            .replace("Boards & paddles", "Daske i vesla")
            .replace("Towables", "Povlačne tube")
            .replace("Replacement accessories", "Rezervna oprema")
            .replace("Mooring & Trailering Covers", "Pokrovi za vez i prijevoz")
            .replace("All-Climate Covers", "Pokrovi za sve vremenske uvjete")
        );

        $('.messages').html((i, t) => t
            .replace(
                'Nu se poate trimite e-mail: adresa de e-mail introdusă nu este listată în baza noastră de date.',
                'Nije moguće poslati e-mail: unesena e-mail adresa nije pronađena u našoj bazi podataka.'
            )
        );

    }

    function able_trans_footer() {
        $("#footer .custom-footer__contact h4").html((i, t) => t.replace("Contact", "Kontakti"));
        $('#footer #formNewsletterWidget input[name="email"]').attr("placeholder", "Vaša email adresa");
        $('#footer #formNewsletterWidget button[type="submit"] > span').html((i, t) => t.replace("Trimitere", "Prijaviti se"));
        $('#formNewsletterWidget input[name="email"]').attr("placeholder", "Vaša e-mail adresa");

        $('#footer, .newsletter-wrapper').html((i, t) => t && t
            .replace(/\bAbonare la newsletter\b/g, "Pretplata na newsletter")
            .replace(/\bAbonare\b/g, "Pretplata")
            .replace(/\bUrmărire pe Instagram\b/g, "Pratite na Instagramu")
            .replace(/\bDrepturi de autor\b/g, "Autorska prava")
            .replace(/\bToate drepturile rezervate\b/g, "Sva prava pridržana")
        );
    }

    function able_trans_category() {
        $(".product a.btn").html((i, t) => t.replace("Adaugă în Coş", "U košaricu"));
        $('.product, .products, .product-tile, .p-to-cart-block, .add-to-cart, .listing').find('button, a, .btn').html((i, t) => t && t
            .replace("Adaugă în Coş", "Dodaj u košaricu")
        );
        $('.product .p-code, .product .p-code *').html((i, t) => t && t
            .replace(/\bCod:/g, "Šifra:")
            .replace(/\bCod\b/g, "Šifra")
        );
        $(".product button.btn span").html((i, t) => t.replace("Adaugă în Coş", "U košaricu"));
        $(".product .p-tools .btn").html((i, t) => t.replace(/Detalii/gi, 'Detalji'));
        $(".product .p-code").html((i, t) => t.replace("Cod", "Kod"));
        $('.product .price-final small').html((i, t) => t.replace("from", "od"));
        $('.product, .product-detail, .products, .box').find('button, a').html((i, t) => t && t.replace("Adaugă în Coş", "Dodaj u košaricu"));
        $('.product-detail, .product, .product-parameters, .parameters, .box').html((i, t) => t && t.replace("Cod:", "Šifra:"));

        $("#filters .slider-wrapper h4,#filters .slider-wrapper .h4title").html((i, t) => t.replace("Price", "Cijena"));
        $("#filters #manufacturer-filter h4,#filters #manufacturer-filter .h4title").html((i, t) => t.replace("Brands", "Brendovi"));
        $('#filters .param-filter-top label[for="stock"]').html((i, t) => t && t.replace(/\bPe stoc\b/g, "Na zalihi"));
        $('#filters .filter-total-count').html((i, t) => t && t
            .replace(/\barticole de afişat\b/g, "artikala za prikaz")
            .replace(/\barticole de afișat\b/g, "artikala za prikaz")
        );
        $('#filters #clear-filters').html((i, t) => t.replace("Remove filters", "Izbrisati filtre"));

        $('#productsTop').prev('h4,.h4').html((i, t) => t.replace("Bestsellers", "Najprodavaniji"));
        $('#productsTop .toggle-top-products').html((i, t) => t.replace("Show more products", "Pogledajte više proizvoda"));
        $("#productsTop .toggle-top-products").attr("data-text", "Prikaži manje proizvoda");

        $('#category-header form ul li, #category-header form #products-listing-order').html((i, t) => t
            .replace("We recommend", "Preporučujemo")
            .replace("Cele mai vândute", "Najprodavaniji")
            .replace("Cele mai scumpe", "Najskuplji")
            .replace("Cele mai ieftine", "Najjeftiniji")
            .replace("Alfabetic", "Po abecedi")
        );

        // $('#category-header .category-header-pagination').html((i, t) => t && t
        //     .replace(/\bPagina\b/g, "Stranica")
        //     .replace(/\bdin\b/g, "od")
        //     .replace(/\barticole în total\b/g, "artikala ukupno")
        // );

        $('body.type-category .js-scroll-top').html((i, t) => t.replace("Up", "Gore"));
        $('body.type-category .pagination-loader .load-products').html((i, t) => t.replace("Produsele următoare", "Drugi proizvodi"));

        $('body.type-category .empty-content-category h2').html((i, t) => t.replace("Produsele sunt în curs de pregătire.", "Proizvodi su u pripremi."));
        $('body.type-category .empty-content-category p').html((i, t) => t.replace("Dar puteţi vizualiza alte categorii.", "Ali možete pregledati druge kategorije."));
        $('body.type-category .empty-content-category .btn').html((i, t) => t.replace("Inapoi în magazin", "Natrag u trgovinu"));

        $('#category-header label[for="products-listing-order"]').html((i, t) => t && t.replace(/Sortează după:/g, "Sortiraj po:"));
        $('#products-listing-order option').text((i, t) => t
            .replace(/Cele mai ieftine/g, "Najjeftiniji")
            .replace(/Cele mai scumpe/g, "Najskuplji")
            .replace(/Cele mai vândute/g, "Najprodavaniji")
            .replace(/Alfabetic/g, "Po abecedi")
        );

        $('#filters .slider-wrapper h4, #filters .slider-wrapper .h4title').html((i, t) => t && t
            .replace(/\bPreţ\b/g, "Cijena")
            .replace(/\bPreț\b/g, "Cijena")
        );
        $('#filters #manufacturer-filter h4, #filters #manufacturer-filter .h4title').html((i, t) => t && t
            .replace(/\bBranduri\b/g, "Brendovi")
        );
        $('#filters .js-toggle-filters, #filters .filter-toggler, #filters .toggle').html((i, t) => t && t
            .replace(/\bDeschidere filtru\b/g, "Otvori filter")
            .replace(/\bAfişare filtru\b/g, "Prikaži filter")
            .replace(/\bAfișare filtru\b/g, "Prikaži filter")
        );
        $('.pagination-loader .load-products').html((i, t) => t && t
            .replace(/\bAfişare mai multe produse\b/g, "Prikaži više proizvoda")
            .replace(/\bAfișare mai multe produse\b/g, "Prikaži više proizvoda")
        );
        $('.product, .products, .availability, .flags, .badge, .status').html((i, t) => t && t
            .replace(/\bPe stoc\b/g, "Na zalihi")
        );

        // $('#category-header .sorting, #category-header').find('*:contains("Sortează după")').html((i, t) => t && t.replace(/Sortează după:/g, "Sortiraj po:"));

        // $('#category-header, .category-header-pagination').html((i, t) => t && t
        //     .replace(/\bPagina\b/g, "Stranica")
        //     .replace(/\bdin\b/g, "od")
        //     .replace(/\barticole în total\b/g, "artikala ukupno")
        // );

        $('#filters, #filters *').html((i, t) => t && t
            .replace(/\bPreţ\b/g, "Cijena")
            .replace(/\bPreț\b/g, "Cijena")
            .replace(/\bBranduri\b/g, "Brendovi")
            .replace(/\bPe stoc\b/g, "Na zalihi")
            .replace(/\bAfişare filtru\b/g, "Prikaži filter")
            .replace(/\bAfișare filtru\b/g, "Prikaži filter")
            .replace(/\bDeschidere filtru\b/g, "Otvori filter")
            .replace(/\barticole de afişat\b/g, "artikala za prikaz")
            .replace(/\barticole de afișat\b/g, "artikala za prikaz")
        );

        $('.products, .product, .listing').find('.availability, .badge, .flag, .status, *').html((i, t) => t && t
            .replace(/\bCod:\b/g, "Šifra:")
            .replace(/\bCod\b/g, "Šifra")
            .replace(/\bAdaugă în Coş\b/g, "Dodaj u košaricu")
            .replace(/\bf(?:ă|a)r[ăa]\s*TVA\b/gi, 'bez PDV-a')
        );

        $('.listingControls #listingControlsHeading').html((i, t) => t && t.replace("Controlul listărilor", "Kontrole popisa"));
        $('.listingControls .loadMore__button').html((i, t) => t && t.replace(/Încarcă încă (\d+)/, "Učitaj još $1"));

        $('.listingControls #paginationTitle').html((i, t) => t && t.replace("Paginare", "Paginacija"));
        $('.listingControls #paginationStatus').text((i, t) => t && t.replace(/Ești pe pagina\s+(\d+).*?din\s+(\d+)/, 'Nalazite se na stranici $1 od $2'));

        $('.listingControls .pagination a[aria-label]').attr('aria-label', (i, v) => v && v
            .replace(/Urm(?:ă|a)toarea, pagina/g, "Sljedeća, stranica")
            .replace(/ultima pagină/g, "zadnja stranica")
        );

        $('.listingControls .itemsTotal').html((i, t) => t && t
            .replace(/\barticole în total\b/g, "artikala ukupno")
            .replace(/\barticole in total\b/g, "artikala ukupno")
        );

        $('.listingControls .goToTop__button').html((i, t) => t && t.replace(/\bSus\b/g, "Gore"));
        $('.listingControls .goToTop__button').attr('aria-label', (i, v) => v && v
            .replace("Sus la începutul listei de articole", "Na vrh popisa artikala")
        );

        $('#category-header .sortingToggle__label').text((i, t) =>
            (t || '').replace('Sortează după:', 'Sortiraj po:')
        );

        $('#category-header .sortingToggle__value').text((i, t) => (t || '')
            .replace(/\bCele mai ieftine\b/g, 'Najjeftiniji')
            .replace(/\bCele mai scumpe\b/g, 'Najskuplji')
            .replace(/\bCele mai vândute\b/g, 'Najprodavaniji')
            .replace(/\bAlfabetic\b/g, 'Po abecedi')
        );

        $('#listSortingControls .listSorting__control').text((i, t) => (t || '')
            .replace(/\bCele mai ieftine\b/g, 'Najjeftiniji')
            .replace(/\bCele mai scumpe\b/g, 'Najskuplji')
            .replace(/\bCele mai vândute\b/g, 'Najprodavaniji')
            .replace(/\bAlfabetic\b/g, 'Po abecedi')
        );

    }

    function able_trans_brands_index() {
        $('head title').text((i, t) => t.replace('Mărcile vândute', 'Prodavane marke'));
        $('#content .category-title, #content h1[data-testid="titleCategory"]')
            .text((i, t) => t.replace('Toate brandurile A-Z', 'Svi brandovi A–Ž'));
        $('.breadcrumbs #navigation-1 [itemprop="name"], .breadcrumbs #navigation-1 [data-title="Mărcile vândute"]')
            .each(function () {
                $(this).text(function (_i, t) {
                    return t.replace("Mărcile vândute", "Prodavane marke");
                });
                const dt = $(this).attr('data-title');
                if (dt) $(this).attr('data-title', dt.replace("Mărcile vândute", "Prodavane marke"));
            });
    }

    function able_trans_cart() {
        $('.cart-header .step-1').html((i, t) => t.replace("Coş de cumpărături", "Košarica za kupovinu"));
        $('.cart-header .step-2 span').text("Dostava i plaćanje");
        $('.cart-header .step-3 span').text("Podaci o vama");
        $('.next-step-forward').html((i, t) => t.replace("Continuare", "Nastaviti"));
    }

    function able_trans_cart_summary() {
        setTimeout(function () {
            $('body #summary-box').html((i, t) => t.replace("GRATUIT", "BESPLATNO"));
        }, 10);
        $('body #summary-box').html((i, t) => t
            .replace("Rezumat comandă", "Pregled narudžbi")
            .replace("Total pentru produse", "Ukupno za robu")
            .replace("Preţ total de plată", "Ukupno za plaćanje")
            .replace("Preţ fără TVA", "Cijena bez PDV-a")
        );

    }

    function able_trans_cart1() {
        $('head title').text((i, t) => t && t.replace("Coș de cumpărături", "Košarica za kupovinu"));
        $('.cart-table .quantity').html((i, t) => t
            .replace("The minimum quantity that can be purchased is 1 buc..", "Minimalna količina koja se može kupiti je 1 kom.")
            .replace("It is not possible to purchase more than 9999 pcs.", "Nije moguće kupiti više od 9999 kom.")
        );
        $('.cart-header .step-1 span, .cart-header .step-1 strong span').each((i, el) => {
            el.innerHTML = el.innerHTML.replace(/Coș de cumpărături|Coş de cumpărături/g, 'Košarica za kupovinu');
        });
        $('.cart-header .step-2 span').each((i, el) => {
            el.innerHTML = el.innerHTML
                .replace(/\bTransport\b/g, 'Dostava')
                .replace(/\bPlată\b/g, 'Plaćanje');
        });
        $('.cart-header .step-3 span').each((i, el) => {
            el.innerHTML = el.innerHTML.replace(/Date de livrare/g, 'Podaci o vama');
        });
        $('.cart-table .cart-table-header').html(function (_, t) {
            return t
                .replace(/\bDisponibilitate\b/g, 'Dostupnost')
                .replace(/\bCantitate\b/g, 'Količina')
                .replace(/\bPreţ pe unitate\b|\bPreț pe unitate\b/g, 'Cijena po komadu')
                .replace(/\bTotal\b/g, 'Ukupno');
        });
        $('.unit-value').html((i, t) => t && t.replace('/ buc.', '/ kom.'));
        $('.increase-tooltip').attr('data-original-title', (i, v) => v && v
            .replace('Nu este posibil să achiziționați mai mult de 9999 buc..', 'Nije moguće kupiti više od 9999 kom.'));
        $('.decrease-tooltip').attr('data-original-title', (i, v) => v && v
            .replace('Cantitatea minimă care poate fi achiziționată este 1 buc..', 'Minimalna količina koja se može kupiti je 1 kom.'));
        $('.cart-table [aria-label]').attr('aria-label', (i, v) => v && v
            .replace('Îndepărtare din coş', 'Ukloni iz košarice')
            .replace('Creşte cantitatea cu 1', 'Povećaj količinu za 1')
            .replace('Scade cantitatea cu 1', 'Smanji količinu za 1')
            .replace(/\bValoare\b/g, 'Vrijednost')
        );
        $('.price-label.price-primary').text((i, t) => t && t.replace('Total pentru produse:', 'Ukupno za proizvode:'));
        $('.price-label.price-secondary').text((i, t) => t && t.replace('Preţ fără TVA:', 'Cijena bez PDV-a:'));
        $('.continue-shopping').text((i, t) => t && t.replace(/Inapoi în magazin|Înapoi în magazin/, 'Natrag u trgovinu'));
        $('#continue-order-button .order-button-text').text((i, t) => t && t.replace('Continuare', 'Nastavi'));
        $('.skip-link').text((i, t) => t && t.replace('Treci la conținut', 'Prijeđi na sadržaj'));
        $('.product-table-name-footer .p-label').text((i, t) => t && t.replace('Disponibilitate', 'Dostupnost'));
        $('.messages .msg-success span').text((i, t) => t && t
            .replace('Cantitatea a fost actualizată cu succes.', 'Količina je uspješno ažurirana.')
            .replace('Articolul din coş a fost şters cu succes.', 'Artikl iz košarice je uspješno obrisan.')
        );
        $('.empty-cart-boxes h3').text((i, t) =>
            t && t
                .replace('Verificaţi sortimentul', 'Provjerite asortiman')
                .replace('Încercaţi opţiunea de căutare', 'Isprobajte pretragu')
        );
        $('.js-try-search-button').text((i, t) =>
            t && t.replace('Căutare', 'Pretraži')
        );
        $('.cart-heading[data-testid="cartTitle"]').text((i, t) =>
            t && t.replace('Coşul dumneavoastră de cumpărături este gol', 'Vaša košarica je prazna')
        );
    }

    function able_trans_cart2() {
        able_trans_cart();
        able_trans_cart_summary();

        $('head title').text((i, t) => t && t.replace('Comandă - plată și transport', 'Narudžba - plaćanje i dostava'));
        $('body.id--16 .order-icon.order-information').html((i, t) => t.replace("Informaţii de bază legate de comandă", "Osnovne informacije vezane uz narudžbu"));
        $('body.id--16 .co-basic-information .form-group .select-label').html((i, t) => t.replace("Ţara de livrare", "Zemlja isporuke"));
        $('body.id--16 .order-icon.order-delivery').html((i, t) => t.replace("Alegeți modalitatea de livrare", "Odaberite način dostave"));
        $('body.id--16 .order-icon.order-payment').html((i, t) => t.replace("Alegeți modalitatea de plată", "Odaberite način plaćanja"));
        $('body.id--16 .co-delivery-method,body.id--16 .co-payment-method').html((i, t) => t.replace("Combinaţia selectată de ţară, metodă de livrare şi modalitate de plată nu este disponibilă.", "Ova kombinacija dostave i plaćanja nije moguća."));
        $('.next-step-back').html((i, t) => t.replace("Înapoi", "Leđa"));
        $('.cart-header .step-1 span').each((i, el) => {
            el.innerHTML = el.innerHTML.replace(/Coș de cumpărături|Coş de cumpărături/g, 'Košarica za kupovinu');
        });
        $('.cart-header .step-2 span').each((i, el) => {
            el.innerHTML = el.innerHTML
                .replace(/\bTransport\b/g, 'Dostava')
                .replace(/\bPlată\b/g, 'Plaćanje');
        });
        $('.cart-header .step-3 span').each((i, el) => {
            el.innerHTML = el.innerHTML.replace(/Date de livrare/g, 'Podaci o vama');
        });
        $('.co-delivery-method h4.order-delivery').text((i, t) => t && t.replace('Alegeți modalitatea de livrare', 'Odaberite način dostave'));
        $('.co-delivery-method').html((i, h) => h && h
            .replace('Combinaţia selectată de ţară, metodă de livrare şi modalitate de plată nu este disponibilă.', 'Odabrana kombinacija zemlje, načina dostave i načina plaćanja nije dostupna.')
        );
        $('.co-payment-method h4.order-payment').text((i, t) => t && t.replace('Alegeți modalitatea de plată', 'Odaberite način plaćanja'));
        $('.co-payment-method .not-possible-info').text((i, t) => t && t.replace(
            'Nu se poate seta această combinaţie de metodă de facturare şi de expediere.',
            'Nije moguće postaviti ovu kombinaciju načina plaćanja i dostave.'
        ));
        $('#summary-box > h4').text((i, t) => t && t.replace('Rezumat comandă', 'Sažetak narudžbe'));
        $('#summary-box .unit-value').text((i, t) => t && t.replace('buc.', 'kom.'));
        $('#summary-box .order-summary-item.helper strong').html((i, h) => h && h.replace('Total pentru produse:', 'Ukupno za proizvode:'));
        $('#summary-box .price-label.price-primary').text((i, t) => t && t.replace('Preţ total de plată:', 'Ukupna cijena za plaćanje:'));
        $('#summary-box .price-label.price-secondary').text((i, t) => t && t.replace('Preţ fără TVA:', 'Cijena bez PDV-a:'));
        $('.next-step--step-1 a.next-step-back').text((i, t) => t && t.replace('Înapoi', 'Natrag'));
        $('#orderFormButton .order-button-text').text((i, t) => t && t.replace('Continuare', 'Nastavi'));
        $('.skip-link').text((i, t) => t && t.replace('Treci la conținut', 'Prijeđi na sadržaj'));
        $('.messages .msg-error span').text((i, t) => t && t.replace(
            'Vă rugăm să alegeţi o metodă de expediere',
            'Molimo odaberite način dostave'
        ));
    }

    function able_trans_cart3() {
        able_trans_cart();
        able_trans_cart_summary();

        $('head title').text((i, t) => t
            .replace("Comandă - Informații despre dvs.", "Narudžba - podaci o vama")
        );
        $('.next-step-back').html((i, t) => t
            .replace("Înapoi", "Leđa")
        );
        $('.next-step-finish').html((i, t) => t
            .replace("Comanda", "Želim naručiti")
            .replace("CU OBLIGAȚIE DE PLATĂ", "s obvezom plaćanja")
        );
        $('.helper').html((i, t) => t
            .replace("Puteți utiliza opțiunea de ", "Možete koristiti opciju ")
            .replace(" dacă sunteți utilizator înregistrat, iar noi vă vom completa automat informațiile.", " ako ste registrirani korisnik — podatke ćemo automatski popuniti.")
        );
        $('.helper a').text((i, t) => t
            .replace("autentificare", "prijave")
            .replace("Autentificare", "Prijaviti")
        );
        $('.co-contact-information h4').html((i, t) => t
            .replace("Date personale", "Osobni podaci")
        );
        $('.co-billing-address h4.header-billing').html((i, t) => t
            .replace("Adresa de facturare", "Adresa za naplatu")
        );
        $('#shipping-address h4').html((i, t) => t
            .replace("Adresă de expediere", "Adresa za dostavu")
        );
        $('#checkoutContent label[for="billFullName"], #checkoutContent label[for="deliveryFullName"]').html((i, t) => t
            .replace("Nume complet", "Ime i prezime")
        );
        $('#checkoutContent label[for="email"]').html((i, t) => t
            .replace("Adresă de e-mail", "E-mail adresa")
        );
        $('#checkoutContent label[for="phone"]').html((i, t) => t
            .replace("Telefon", "Telefon")
        );
        $('#checkoutContent label[for="billStreet"], #checkoutContent label[for="deliveryStreet"]').html((i, t) => t
            .replace("Str., Nr., Bl., Sc., Ap.", "Ulica i kućni broj")
        );
        $('#checkoutContent label[for="billCity"], #checkoutContent label[for="deliveryCity"]').html((i, t) => t
            .replace("Localitate", "Grad")
        );
        $('#checkoutContent label[for="billZip"], #checkoutContent label[for="deliveryZip"]').html((i, t) => t
            .replace("Cod poştal", "Poštanski broj")
            .replace("Cod poștal", "Poštanski broj")
        );
        $('#checkoutContent label[for="billCountryId"]').html((i, t) => t
            .replace("Ţară", "Zemlja")
            .replace("Țară", "Zemlja")
        );
        $('#checkoutContent label[for="company-shopping"]').text("Kupujem za tvrtku");
        $('#checkoutContent label[for="companyId"]').html((i, t) => t
            .replace("Cod fiscal", "Porezni broj (OIB)")
        );
        $('#checkoutContent label[for="vatId"]').html((i, t) => t
            .replace("Nr. TVA UE", "PDV broj (EU)")
        );
        $('#checkoutContent label[for="billCompany"]').html((i, t) => t
            .replace("Numele companiei", "Naziv tvrtke")
        );
        $('#checkoutContent label[for="deliveryCompany"]').html((i, t) => t
            .replace("Companie", "Naziv tvrtke")
        );
        $('#checkoutContent label[for="another-shipping"]').text("Dostava na drugu adresu");
        $('#checkoutContent label[for="add-note"]').text("Unesite napomenu za prodavatelja");
        $('#checkoutContent #remark').attr('placeholder', "Vaša bilješka");
        $('#checkoutContent .stay-in-touch h4').html((i, t) => t
            .replace("Păstrăm legătura", "Ostanimo u kontaktu")
        );
        $('#checkoutContent .stay-in-touch label[for="sendNewsletter"]').html((i, t) => t
            .replace("Nu doresc să primesc noutăți pe e-mail", "Ne želim primati novosti e-poštom")
        );
        $('#checkoutContent .stay-in-touch label[for="set-registration"]').html((i, t) => t
            .replace("Vreau să mă înregistrez", "Želim se registrirati")
        );
        $('#checkoutContent .stay-in-touch #reg-info').html((i, t) => t
            .replace("(Informațiile de înregistrare vă vor fi trimise prin e-mail)", "(Informacije o registraciji bit će vam poslane e-poštom)")
        );
        $('#checkoutContent label[for="deliveryCountryId"]').html((i, t) => t
            .replace('Ţară', 'Zemlja')
            .replace('Țară', 'Zemlja')
        );
        $('#checkoutContent label[for="deliveryCountryId"]')
            .next('strong')
            .text((i, t) => t.replace('Croația', 'Hrvatska'));
        $('#checkoutContent .helpNote').html((i, t) => t
            .replace('Se poate edita la ', 'Može se urediti u ')
            .replace('pasul anterior', 'prethodnom koraku')
        );
        $('.order-summary-item .unit-value').text((i, t) => t.replace('buc.', 'kom.'));
    }

    function able_trans_cart_thanks() {
        $('head title').text((i, t) => t
            .replace("Vă mulțumim pentru comandă", "Hvala na Vašoj narudžbi")
            .replace("Vă mulţumim pentru comandă", "Hvala na Vašoj narudžbi")
        );

        $('#content h1.order-summary-heading, .order-summary-heading').text((i, t) => t
            .replace("Comandă plasată", "Narudžba poslana")
        );

        $('#content .content-inner').html((i, t) => t
            .replace("Vă mulțumim pentru comanda dumneavoastră numărul", "Hvala vam na vašoj narudžbi broj")
            .replace("Vă mulţumim pentru comanda dumneavoastră numărul", "Hvala vam na vašoj narudžbi broj")
            .replace("Veţi primi pe e-mail confirmarea comenzii.", "Također ćemo vam poslati sažetak e-poštom.")
            .replace("Veți primi pe e-mail confirmarea comenzii.", "Također ćemo vam poslati sažetak e-poštom.")
        );

        $('#content .co-payment-method h4').text((i, t) => t
            .replace("Plată şi livrare", "Plaćanje i dostava")
            .replace("Plată și livrare", "Plaćanje i dostava")
        );

        $('#content .recapitulation-table, #content .recapitulation-table-payment').html((i, t) => t
            .replace("Metoda de livrare", "Odabrani prijevoz")
            .replace("Metoda de plată", "Odabrano plaćanje")
            .replace("Total de plată", "Ukupan iznos za plaćanje")
            .replace("Cont bancar", "Bankovni račun")
            .replace("Simbol variabil", "Varijabilni simbol")
            .replace("IBAN", "IBAN")
            .replace("BIC (SWIFT)", "BIC (SWIFT)")
        );

        $('#content .co-order h4').text((i, t) => t
            .replace("Conţinut comandă", "Narudžba uključuje")
            .replace("Conținut comandă", "Narudžba uključuje")
        );

        $('#content .cart-table .cart-table-header').html((i, t) => t
            .replace("Cantitate", "Količina")
            .replace("Preţ pe unitate", "Cijena po komadu")
            .replace("Preț pe unitate", "Cijena po komadu")
            .replace("Total", "Ukupno")
        );

        $('#content .order-summary-item.total').text((i, t) => t
            .replace("Veţi primi pe e-mail confirmarea comenzii.", "Također ćemo vam poslati sažetak e-poštom.")
            .replace("Veți primi pe e-mail confirmarea comenzii.", "Također ćemo vam poslati sažetak e-poštom.")
        );

        $('#content .order-summary-item.summary-thx').html((i, t) => t
            .replace("Vă mulţumim!", "Hvala vam!")
            .replace("Vă mulțumim!", "Hvala vam!")
        );

        $('#content .order-complete-links a.btn.btn-conversion').html((i, t) => t
            .replace("Inapoi în magazin", "Natrag u trgovinu")
            .replace("Înapoi în magazin", "Natrag u trgovinu")
        );
    }

    function able_trans_contact_form() {
        $('.contact-form p').text('Imate pitanja? Rado ćemo odgovoriti. Molimo ispunite točno svoje kontakt podatke.');
        $('.contact-form label[for="fullName"] .required-asterisk').text('Puno ime');
        $('.contact-form label[for="email"] .required-asterisk').text('Email adresa');
        $('.contact-form label[for="message"] .required-asterisk').text('Poruka');
        $('.contact-form .submit-wrapper input[type="submit"]').val('Pošalji');
    }

    function able_trans_404() {
        $('head title').text((i, t) => t
            .replace("Pagina nu există", "Stranica ne postoji")
        );
        $('.breadcrumbs #navigation-1 [itemprop="name"], .breadcrumbs #navigation-1 [data-title="Pagina nu există"]')
            .each(function () {
                $(this).text(function (_i, t) {
                    return t.replace("Pagina nu există", "Stranica ne postoji");
                });
                const dt = $(this).attr('data-title');
                if (dt) $(this).attr('data-title', dt.replace("Pagina nu există", "Stranica ne postoji"));
            });
        $('#content h1[data-testid="pageHeader"]').text(function (_i, t) {
            return t.replace("Eroare! A survenit o problemă.", "Pogreška! Došlo je do problema.");
        });
        $('#content h2').text(function (_i, t) {
            return t.replace("Pagina nu a fost găsită.", "Stranica nije pronađena.");
        });
        $('#content h2 + p').text(function (_i, t) {
            return t.replace("Dar puteţi să vă uitaţi la produsele noastre.", "Ali možete pogledati naše proizvode.");
        });
        $('#content [data-testid="buttonBackToShop"]').text(function (_i, t) {
            return t.replace("Inapoi în magazin", "Natrag u trgovinu");
        });
    }

    function able_trans_product() {
        $('.p-data-wrapper .brand-wrapper').html((i, t) => t.replace("Brand", "Ocjena"));
        $('.p-data-wrapper .detail-parameters').html((i, t) => t
            .replace("Availability", "Dostupnost")
            .replace("Cod", "Kod")
        );
        $('.p-data-wrapper .add-to-cart .quantity').html((i, t) => t
            .replace("The minimum quantity that can be purchased is 1 buc..", "Minimalna količina koja se može kupiti je 1 kom.")
            .replace("It is not possible to purchase more than 9999 pcs.", "Nije moguće kupiti više od 9999 kom.")
        );
        $('.p-data-wrapper .add-to-cart-button').html((i, t) => t.replace("To cart", "U košaricu"));

        $('.social-buttons-wrapper .link-icon.print span').html((i, t) => t.replace("Print", "Ispis"));
        $('.social-buttons-wrapper .link-icon.chat span').html((i, t) => t.replace("Ask", "Pitajte"));
        $('.social-buttons-wrapper .link-icon.watchdog span').html((i, t) => t.replace("Watch", "Gledati"));
        $('.social-buttons-wrapper .link-icon.share span').html((i, t) => t.replace("Share", "Udio"));
        $('.social-buttons-wrapper .close-after').html((i, t) => t.replace("Close", "Zatvoriti"));

        $('.products-related-header,#p-detail-tabs li a ').text((i, t) => t
            .replace("Description", "Opis")
            .replace("Brand", "Ocjena")
            .replace("Related products", "Povezani proizvodi")
            .replace("Product parameters", "Parametri")
        );

        $('body.type-detail .p-code .p-code-label').html((i, t) => t.replace("Cod", "Kod"));
        $('body.type-detail .p-code .default-variant').html((i, t) => t.replace("Alegeţi varianta", "Odaberite varijantu"));
        $('body.type-detail .cart-inner-wrapper .availability-wrapper .availability-label').html((i, t) => t.replace("Alegeţi varianta", "Odaberite varijantu"));
        $('body.type-detail .p-to-cart-block .btn').html((i, t) => t.replace("Adaugă în Coş", "Dodaj u košaricu"));
        $('body.type-detail .p-final-price-wrapper .price-additional').html((i, t) => t.replace(/\bf(?:ă|a)r[ăa]\s*TVA\b/gi, 'bez PDV-a'));
        $('body.type-detail .shp-tabs-holder .p-detail-tabs .shp-tab-link').html((i, t) =>
            t.replace("Descriere", "Opis").replace("Discuţie", "Rasprava")
        );
        $('body.type-detail .p-detail-tabs-wrapper #description .basic-description p').html((i, t) => t.replace("Descrierea produsului nu este disponibilă", "Opis proizvoda nije dostupan"));
        $('body.type-detail .p-detail-tabs-wrapper #productDiscussion .discussionContainer p').html((i, t) => t.replace("Fiţi prima persoană care va posta un articol la acest produs!", "Budite prvi koji će objaviti članak za ovaj proizvod!"));
        $('body.type-detail .p-detail-tabs-wrapper #formDiscussion .smart-label-wrapper label')
            .html((i, t = '') => t
                .replace('Nume', 'Ime')
                .replace('Titlu', 'Naslov')
                .replace('Comentariu', 'Komentar')
                .replace('Copiați textul din imagine', 'Kopirajte tekst sa slike')
            );
        $('body.type-detail .p-detail-tabs-wrapper #formDiscussion .smart-label-wrapper label .required-asterisk').html((i, t) => t.replace('Adresă de e-mail', 'Adresa e-pošte'));
        $('body.type-detail .p-detail-tabs-wrapper #formDiscussion .box h4').html((i, t) => t.replace("Verificare de siguranță", "Sigurnosna provjera"));
        $('body.type-detail .p-detail-tabs-wrapper #formDiscussion .btn').val((i, v) => (v || '').replace('Trimite un comentariu', 'Pošaljite komentar'));
        $('.shp-accordion .shp-accordion-link').html((i, t = '') => t
            .replace("Descriere", "Opis")
            .replace(/Discu[tț]ie/i, "Rasprava")
            .replace("Marcă", "Brend")
        );
        $('body.type-detail #description .basic-description').html((i, t = '') =>
            t.replace("Descrierea produsului nu este disponibilă", "Opis proizvoda nije dostupan")
        );
        $('#description .extended-description strong').html((i, t = '') =>
            t.replace("Parametri suplimentari", "Dodatni parametri")
        );
        $('#description table.detail-parameters .row-header-label').html((i, t = '') => t
            .replace("Categorie", "Kategorija")
            .replace("Garanţie", "Jamstvo")
        );
        $('#description table.detail-parameters td').html((i, t = '') =>
            t.replace(/(\d+)\s*ani\b/g, '$1 godine')
        );
        $('[data-testid="tabBrand"] > a.shp-accordion-link').html((i, t = '') =>
            t.replace("Marcă", "Brend")
        );
        $('[data-testid="buttonAddComment"]').html((i, t = '') =>
            t.replace("Adăugare comentariu", "Dodajte komentar")
        );
        $('#formDiscussion #fullName').attr('placeholder', (i, v = '') =>
            v.replace("Nume", "Ime")
        );
        $('#formDiscussion #email').attr('placeholder', (i, v = '') =>
            v.replace("Adresă de e-mail", "Adresa e-pošte")
        );
        $('#formDiscussion #title').attr('placeholder', (i, v = '') =>
            v.replace("Titlu", "Naslov")
        );
        $('#formDiscussion #message').attr('placeholder', (i, v = '') =>
            v.replace("Comentariu", "Komentar")
        );
        $('#formDiscussion input[type="submit"]').val((i, v = '') =>
            v.replace("Trimite un comentariu", "Pošaljite komentar")
        );
        $('#formDiscussion .consents-first label').html((i, t = '') => t
            .replace("Introducând comentariul, acceptați", "Unosom komentara prihvaćate")
            .replace("condițiile de protecție a datelor cu caracter personal", "uvjete zaštite osobnih podataka")
        );
        $('#productDiscussion .discussionContainer p[data-testid="textCommentNotice"]').html((i, t='') =>
            t.replace("Fiţi prima persoană care va posta un articol la acest produs!",
                "Budite prvi koji će objaviti članak za ovaj proizvod!")
        );
        $('.shp-accordion[data-testid="tabDiscussion"] .shp-accordion-link')
            .text((i, t) => t.replace("Discuţie", 'Rasprava'));
    }

    function able_trans_forgot_password() {
        $('head title').text((i, t) => t.replace('Resetați parola', 'Zaboravljena lozinka'));
        $('body.id--7 #content h1, body.id--7 .breadcrumbs span[data-title="Parola uitată"]').html((i, t) => t.replace("Parola uitată", "Zaboravljena lozinka"));
        $('body.id--7 #content label, body.id--7 #content h2').html((i, t) => t.replace("Adresa dumneavoastră de e-mail", "Tvoj email"));
        $('body.id--7 #content .no-display').html((i, t) => t.replace("You cannot fill out this field", "Ne možete ispuniti ovo polje"));
        $('body.id--7 #content div.login-wrapper input[type="submit"]').attr("value", "Poslati");
        $('body.id--7 #formForgottenPassword p').html((i, t) => t.replace("Vă rugăm să introduceți adresa de e-mail, pe care aţi utilizat-o în momentul înregistrării. Vă vom trimite un link pentru setarea parolei dvs.", "Unesite email adresu koju ste koristili za registraciju. Poslat ćemo vam poveznicu za postavljanje lozinke."));
        $('#formForgottenPassword h2').text((i, t) => t.replace(/Adresa.*e-mail/i, 'Vaša e-mail adresa'));
        $('#formForgottenPassword p').text((i, t) => t.replace(
            /Vă rugăm să introduceți.*parolei dvs\./i,
            'Unesite adresu e-pošte koju ste koristili pri registraciji. Poslat ćemo vam poveznicu za ponovno postavljanje lozinke.'
        ));
        $('#formForgottenPassword label[for="email"]').text((i, t) => t.replace(/Adresa.*e-mail:/i, 'Vaša e-mail adresa:'));
        $('#formForgottenPassword .no-display').text((i, t) => t.replace(/Nu completaţi acest câmp:/i, 'Ne ispunjavajte ovo polje:'));
        $('[data-testid="buttonSend"]').val((i, t) => t.replace(/Trimitere|Poslati/i, 'Pošalji'));
        $('.breadcrumbs #navigation-first [itemprop="name"]').text((i, t) =>
            t.replace(/^Dom$|^Acasă$/i, 'Početna')
        );
        $('[data-testid="breadcrumbsLastLevel"] [itemprop="name"]')
            .text((i, t) => t.replace(/Resetați parola/i, 'Zaboravljena lozinka'))
            .attr('data-title', 'Zaboravljena lozinka');
    }

    function able_trans_registration_inputs() {
        $('.co-registration h4').html((i, t) => t.replace("Are you a robot?", "Jeste li robot?"));
        $('.stay-in-touch label[for="sendNewsletter"]').html((i, t) => t.replace("for over 16 years old", "para mayores de 16 años"));
        $('#register-form h4').html((i, t) => t.replace("Confirmare", "Potvrda"));
        $('#content h4').html((i, t) => t.replace("Tip de client", "Vrsta kupca").replace("Date personale", "Osobni podaci"));
        $('#content label[for="email"]').html((i, t) => t.replace("Adresă de e-mail", "Email"));
        $('#content label[for="passwordAgain"]').html((i, t) => t.replace("Introduceţi din nou parola", "Lozinka (provjeri)"));
        $('#content label[for="password"]').html((i, t) => t.replace("Parolă", "Lozinka"));
        $('#content label').html((i, t) => t.replace("I do not wish to receive newsletters", "Ne želim primati biltene"));

        $('.stay-in-touch h4').html((i, t) => t.replace("Stay in touch", "Ostanimo u kontaktu"));
        $('#content h4.header-billing').html((i, t) => t.replace("Adresa de facturare", "Adresa za naplatu"));
        $('#content label[for="companyId"]').html((i, t) => t.replace("CIN", "OIB"));
        $('#content label[for="vatId"]').html((i, t) => t.replace("VAT number", "PDV-ID"));
        $('#content label[for="billCompany"]').html((i, t) => t.replace("Company name", "Naziv tvrtke"));
        $('#content label[for="billFullName"]').html((i, t) => t.replace("Full name", "Ime i prezime"));
        $('#content label[for="phone"]').html((i, t) => t.replace("Telefon", "Telefon"));
        $('#content label[for="billStreet"]').html((i, t) => t.replace("Street, House no.", "Ulica i kućni broj"));
        $('#content label[for="billCity"]').html((i, t) => t.replace("Localitate", "Grad"));
        $('#content label[for="billZip"]').html((i, t) => t.replace("Cod poştal", "Poštanski broj"));
        $('#content label[for="billCountryId"]').html((i, t) => t.replace("Ţară", "Zemlja"));
    }

    function able_trans_registration() {
        $('head title').text((i, t) => t
            .replace("Înregistrare", "Registracija")
            .replace("Registration", "Registracija")
            .replace("Registrace", "Registracija")
        );
        $('#content h1, body.id--8 .breadcrumbs span[data-title="Registration"]').html((i, t) => t
            .replace("Înregistrare", "Registracija")
            .replace("Registration", "Registracija")
            .replace("Registrace", "Registracija")
        );
        $('.register-soc h4').html((i, t) => t
            .replace("Înregistrare cu reţele sociale", "Registrirajte se putem društvenih mreža")
            .replace("Register with social networks", "Registrirajte se putem društvenih mreža")
        );
        $('.register-soc .login-btn.google').html((i, t) => t
            .replace("Register with Google", "Registrirajte se putem Googlea")
        );
        $('.register-soc .login-btn.facebook').html((i, t) => t
            .replace("Register with Facebook", "Registrirajte se putem Facebooka")
        );
        $('.register-soc .login-btn.seznam').html((i, t) => t
            .replace("Register with Seznam", "Registrirajte se putem Seznama")
        );
        $('.co-registration h4').html((i, t) => t
            .replace("Verificare de siguranță", "Sigurnosna provjera")    // captcha blok
            .replace("Tip client", "Vrsta kupca")
        );
        $('label[for="retail"]').html((i, t) => t
            .replace("Koncový zákazník", "Maloprodajni kupac")
            .replace("Client final", "Maloprodajni kupac")
        );
        $('label[for="wholesale"]').html((i, t) => t
            .replace("Velkoobchodní odběratel", "Veleprodajni kupac")
            .replace("Distribuitor en-gros", "Veleprodajni kupac")
            .replace("Registrace bude schválena v nejbližší době", "Registracija će biti odobrena u najkraćem roku")
            .replace("Înregistrarea va fi aprobată în cel mai scurt timp", "Registracija će biti odobrena u najkraćem roku")
        );
        $('#company-shopping').next('label').html((i, t) => t
            .replace("Specificaţi detaliile companiei", "Unesite podatke o tvrtki")
        );
        $('#additionalInformation h4.header-billing').html((i, t) => t
            .replace("Adresă de facturare", "Adresa za naplatu")
        );
        $('label[for="companyId"]').text((i, t) => t
            .replace("Cod fiscal", "OIB")
            .replace("CIN", "OIB")
        );
        $('label[for="vatId"]').text((i, t) => t
            .replace("Nr. TVA UE", "PDV-ID")
            .replace("VAT number", "PDV-ID")
        );
        $('#vatId')
            .attr('placeholder', "HR12345678901")
            .attr('autocomplete', 'off');
        $('.form-group-hasTooltip .question-tooltip')
            .attr('data-original-title', 'OIB s HR ako ste obveznik PDV-a')
            .attr('title', 'OIB s HR ako ste obveznik PDV-a');
        $('#vatId-description').text('OIB s HR ako ste obveznik PDV-a');
        $('label[for="billCompany"]').text((i, t) => t
            .replace("Numele companiei", "Naziv tvrtke")
            .replace("Company name", "Naziv tvrtke")
        );
        $('label[for="billFullName"] .required-asterisk').html((i, t) => t
            .replace("Nume complet", "Ime i prezime")
        );
        $('label[for="billStreet"] .required-asterisk').html((i, t) => t
            .replace("Str., Nr., Bl., Sc., Ap.", "Ulica i kućni broj")
        );
        $('label[for="billCity"] .required-asterisk').html((i, t) => t
            .replace("Localitate", "Grad")
        );
        $('label[for="billZip"] .required-asterisk').html((i, t) => t
            .replace("Cod poștal", "Poštanski broj")
            .replace("Cod poştal", "Poštanski broj")
        );
        $('label[for="billCountryId"] .required-asterisk, label[for="billCountryId"]').html((i, t) => t
            .replace("Ţară", "Zemlja")
            .replace("Țară", "Zemlja")
        );
        $('label[for="phone"] .required-asterisk').html((i, t) => t
            .replace("Telefon", "Telefon")
        );
        $('.stay-in-touch h4').html((i, t) => t
            .replace("Păstrăm legătura", "Ostanimo u kontaktu")
        );
        $('label[for="sendNewsletter"]').html((i, t) => t
            .replace("Nu doresc să primesc noutăți pe e-mail", "Ne želim primati novosti e-poštom")
        );
        $('label[for="consents28"]').html((i, t) => t
            .replace("Registrací souhlasíte s", "Registracijom prihvaćate")
            .replace("obchodními podmínkami", "Uvjete poslovanja")
            .replace("podmínkami ochrany osobních údajů", "Pravila privatnosti")
        );
        $('.co-registration .required-asterisk').html((i, t) => t
            .replace("Copiați textul din imagine", "Opišite tekst sa slike")
        );
        $('#content div.submit-wrapper input[type="submit"]').attr("value", "Registar");

        able_trans_registration_inputs();
    }

    function able_trans_cartwidget() {
        $('#header .cart-count .cart-price').html((i, t) => t.replace("Coş gol", "Prazna košara"));
        $('.cart-widget #continue-order-button').text((i, t) => t.replace("Continuare către coş", "Nastavite do košarice"));
        $('.cart-widget div.cart-widget-product').html((i, t) => t.replace("Coşul dumneavoastră de cumpărături este gol", "Vaša košarica je prazna"));
        $('.cart-widget div.cart-widget-product').html((i, t) => t.replace("Coşul dumneavoastră de cumpărături este gol", "Vaša košarica je prazna"));
        $('#cart-widget .popup-widget-inner .cart-free-shipping div').html((i, t) => t
            .replace("Adăugaţi în comandă articole în valoare de", "Dodajte artikle u svoju narudžbu u vrijednosti od")
            .replace("pentru a vă califica pentru livrare", "da se kvalificira za isporuku")
            .replace("GRATUITĂ", "BESPLATNO")
        );
    }

    function able_trans_advancedOrder() {
        $('.advanced-order .h1').html((i, t) => t.replace("Adăugat în coş", "Dodano u košaricu"));
        $('.advanced-order .delivery').html((i, t) => t
            .replace("Adăugaţi în comandă articole în valoare de", "Dodajte artikle u svoju narudžbu u vrijednosti od")
            .replace("pentru a vă califica pentru livrare", "da se kvalificira za isporuku")
            .replace("GRATUITĂ", "BESPLATNO")
        );
        $('.advanced-order .delivery.shipping-is-free').html((i, t) => t.replace("Beneficiaţi de livrare gratuită!", "Uživajte u besplatnoj dostavi!"));
        $('.advancedOrder__buttons .next-step-back').html((i, t) => t.replace("Inapoi în magazin", "Natrag u trgovinu"));
        $('.advancedOrder__buttons .btn-conversion').html((i, t) => t.replace("Coş de cumpărături", "Košarica za kupnju"));
    }

    function able_trans_notification() {


        $('.messages .msg').html((i, t) => t
            .replace("Items have been added to", "Proizvod je dodan u")
            .replace("shopping cart", "košaricu")
            .replace("Amount was successfully updated.", "Količina je uspješno promijenjena.")
            .replace("Cart item was successfully deleted.", "Stavka košarice je uklonjena.")
            .replace("Choose variant", "Odaberite varijantu")
        );
    }

    function able_trans_cookies() {
        $('.siteCookies .siteCookies__button').text((i, t) => t.replace('Sunt de acord', 'Slažem se').replace('Respinge', 'Odbiti'));
        $('.siteCookies .js-cookies-settings').text((i, t) => t.replace("Setări", "Postavke"));
        $('.siteCookies .siteCookies__text').html((i, t) => t && t
            .replace(
                "K personalizaci obsahu a reklam, poskytování funkcí sociálních médií a analýze naší návštěvnosti využíváme soubory cookies. Více informací",
                "Za personalizaciju sadržaja i oglasa, omogućavanje funkcija društvenih mreža i analizu prometa koristimo kolačiće. Više informacija"
            )
        );
        if ($('body').find('.cookiesSetting__form').length > 0) {
            $('.cookiesSetting__form h2').text((i, t) => t.replace("Setări cookie-uri", "Postavke cookies"));
            $('.cookiesSetting__form .cookiesSetting__perex').text((i, t) => t.replace("Utilizăm module cookie pentru a vă permite să navigați confortabil pe site și pentru a îmbunătăți în mod continuu funcționalitatea, performanța și ușurința de utilizare a site-ului prin analizarea traficului acestuia", "Cookies koristimo kako bismo vam omogućili udobnu navigaciju stranicom i kontinuirano poboljšavali funkcionalnost, performanse i jednostavnost korištenja stranice analizom prometa."));
            $('.cookiesSetting__form .cookiesSetting__data').html((i, t) => t
                .replace("Necesar", "Neophodni")
                .replace("(întotdeauna activ nu poate fi dezactivat)", "(uvijek aktivno ne može se isključiti)")
                .replace("Aceste cookie-uri sunt necesare pentru ca site-ul web să funcționeze corect", "Ovi su cookies potrebni za ispravno funkcioniranje web stranice")
                .replace("Pentru motive analitice", "Analitičke svrhe")
                .replace("Pentru a înțelege mai bine cum utilizați website-ul  și pentru a facilita îmbunătățirile continue.", "Kako bismo mogli saznati kako koristite web stranicu i nastaviti je poboljšavati.")
                .replace("În vederea identificarii profilului clientilor", "Svrhe profiliranja")
                .replace("(marketing)", "(marketing)")
                .replace("Pentru a afișa conținut și reclame relevante care ar putea fi de interes și valoare pentru dvs.", "Kako bismo vam mogli pokazati relevantan sadržaj i oglase koji bi vam mogli biti zanimljivi i korisni.")
                .replace("Enable", "Upaliti")
            );
            $('.cookiesSetting__form .cookiesSetting__uncheckLink').text((i, t) => t.replace("Toate oprite", "Sve isključeno"));
            $('.cookiesSetting__form .cookiesSetting__button').text((i, t) => t
                .replace("Confirmați-mi alegerile", "Potvrdi moje izbore")
                .replace("Activați totul", "Dopusti sve")
            );
            $('.cookiesSetting__form .cookiesSetting__item__state').text((i, t) => t.replace("Porniți", "Okrenuti"));
        }
    }

    able_trans_header()
    able_trans_footer()

//Změna hlášek Shoptetu
    function changeMessages() {
        shoptet.messages['PIScountryOptionMoreBanks'] = 'Možnost platby z %1 bank';
        shoptet.messages['PIScountryOptionOneBank'] = 'Možnost platby z 1 banky';
        shoptet.messages['PIScurrencyInfoCZK'] = 'V měně CZK lze zaplatit pouze prostřednictvím českých bank.';
        shoptet.messages['PIScurrencyInfoHUF'] = 'V měně HUF lze zaplatit pouze prostřednictvím maďarských bank.';
        shoptet.messages['ajaxError'] = 'Došlo je do pogreške; molimo osvježite stranicu i pokušajte ponovno.';
        shoptet.messages['amountChanged'] = '(količina je promijenjena)';
        shoptet.messages['cancel'] = 'Otkazati';
        shoptet.messages['change'] = 'Mijenjati';
        shoptet.messages['charsNeeded'] = 'Molimo koristite najmanje 3 znaka!';
        shoptet.messages['choose-ceska-posta'] = 'Pobočka České Pošty není určena, zvolte prosím některou';
        shoptet.messages['choose-dpd-cz'] = 'Niti jedna od poslovnica DPD Parcel Shop servisa nije odabrana, odaberite jednu od opcija.';
        shoptet.messages['choose-external-shipping'] = 'Molimo navedite odabrani način prijevoza';
        shoptet.messages['choose-glsCz'] = 'Poslovnica GLS ParcelShop nije odabrana, odaberite jednu';
        shoptet.messages['choose-hupostPostaPont'] = 'Pobočka Maďarské pošty není vybrána, zvolte prosím nějakou';
        shoptet.messages['choose-personal-collection'] = 'Prosím vyberte místo doručení u osobního odběru, není zvoleno.';
        shoptet.messages['choose-postSk'] = 'Pobočka Slovenské pošty není zvolena, vyberte prosím některou';
        shoptet.messages['choose-ppl-cz'] = 'PPL ParcelShop podružnica nije odabrana, odaberite jednu';
        shoptet.messages['choose-ulozenka'] = 'Pobočka Uloženky nebyla zvolena, prosím vyberte některou';
        shoptet.messages['choose-zasilkovna'] = 'Pobočka Zásilkovny nebyla zvolena, prosím vyberte některou';
        shoptet.messages['chooseVariant'] = 'Odaberite varijantu';
        shoptet.messages['chosenBranch'] = 'Odabrana grana';
        shoptet.messages['discountCouponWarning'] = 'Zaboravili ste primijeniti kupon za popust. Za nastavak primijenite ga pomoću gumba pored polja za unos ili ga izbrišite.';
        shoptet.messages['emptyCart'] = 'Prazna košara';
        shoptet.messages['hideContacts'] = 'Sakrij kontakte';
        shoptet.messages['invalidCompanyId'] = 'Nevažeći ID broj, dopuštene su samo znamenke';
        shoptet.messages['length'] = '0';
        shoptet.messages['lightboxImg'] = 'Slika';
        shoptet.messages['lightboxOf'] = 'iz';
        shoptet.messages['more'] = 'Više';
        shoptet.messages['needHelp'] = 'Trebaš li pomoć?';
        shoptet.messages['privacyPolicy'] = 'Morate se složiti s politikom privatnosti';
        shoptet.messages['removedItem'] = 'Artikl je uklonjen iz košarice.';
        shoptet.messages['showContacts'] = 'Prikaz kontakata';
        shoptet.messages['specifyShippingMethod'] = 'Navedite otpremu';
        shoptet.messages['textWasTransformed'] = 'Veličina fonta je prilagođena';
        shoptet.messages['toCart'] = 'U košaricu';
        shoptet.messages['unavailableCombination'] = 'Nije dostupno u ovoj kombinaciji';
        shoptet.messages['unavailableVariant'] = 'Ova varijanta nije dostupna i ne može se naručiti.';
        shoptet.messages['validatorCheckbox'] = 'Molimo unesite sva potrebna polja';
        shoptet.messages['validatorConsent'] = 'Ne može se poslati bez pristanka.';
        shoptet.messages['validatorDate'] = 'Unesite važeći datum';
        shoptet.messages['validatorDigits'] = 'Unesite samo brojeve';
        shoptet.messages['validatorEmail'] = 'Unesite važeću adresu e-pošte';
        shoptet.messages['validatorFullName'] = 'Zaboravili ste svoje prezime?';
        shoptet.messages['validatorHouseNumber'] = 'Molimo unesite točan kućni broj';
        shoptet.messages['validatorInvalidCompanyId'] = 'Nevažeći ID, mora biti u obliku %1';
        shoptet.messages['validatorInvalidPhoneNumber'] = 'Unesite važeći telefonski broj bez pozivnog broja.';
        shoptet.messages['validatorNumber'] = 'Unesite važeći broj telefona';
        shoptet.messages['validatorPassword'] = 'Lozinke se ne podudaraju';
        shoptet.messages['validatorRequired'] = 'Obavezno polje';
        shoptet.messages['validatorShortPhoneNumber'] = 'Telefonski broj mora imati min. 8 znakova';
        shoptet.messages['validatorSreet'] = 'Molim bez kućnog broja';
        shoptet.messages['validatorStreet'] = 'Molim bez kućnog broja';
        shoptet.messages['validatorTextWasTransformed'] = 'Veličina fonta je prilagođena';
        shoptet.messages['validatorUrl'] = 'Unesite važeći URL';
        shoptet.messages['validatorVatIdInvalid'] = 'PDV broj nije moguće potvrditi, ali još uvijek možete dovršiti narudžbu';
        shoptet.messages['validatorVatIdValid'] = 'Provjereno';
        shoptet.messages['validatorVatIdWaiting'] = 'Mi provjeravamo';
        shoptet.messages['validatorZipCode'] = 'Uneseni poštanski broj ne odgovara odabranoj državi';
        shoptet.messages['variantWarning'] = 'Odaberite varijantu proizvoda.';
        shoptet.messages['watchdog-consent-required'] = 'Morate provjeriti sve potrebne suglasnosti';
        shoptet.messages['watchdogEmailEmpty'] = 'Molimo ispunite e-mail';
        shoptet.messages['watchdogType'] = 'Potrebno je odabrati jednu od opcija za praćenje proizvoda.';
    }

    function able_trans_sidebar() {
        $('.client-center-box a[href="/centru-clienti/"]').html((i, t) => t
            .replace("Secţiune pentru clienţi", "Centar za korisnike")
        );
        $('.client-center-box .logout a').text((i, t) => t
            .replace("Deconectare", "Odjava")
        );
        $('.client-center-box a[href="/centru-clienti/configurarea-contului-meu/"]').text((i, t) => t
            .replace("Detaliile mele personale", "Moji osobni podaci")
        );
        $('.client-center-box a[href="/centru-clienti/comenzile-mele/"]').text((i, t) => t
            .replace("Comenzile mele", "Moje narudžbe")
        );
        $('.client-center-box a[href="/centru-clienti/platile-clientilor/"]').text((i, t) => t
            .replace("Plățile mele", "Moja plaćanja")
        );
        $('.client-center-box a[href="/centru-clienti/documentele-mele/"]').text((i, t) => t
            .replace("Facturile mele", "Moji računi")
        );
        $('.client-center-box a[href="/centru-clienti/facturi-proforma-client/"]').text((i, t) => t
            .replace("Facturile mele proforma", "Moji predračuni")
        );
        $('.client-center-box a[href="/centru-clienti/note-de-credit-client/"]').text((i, t) => t
            .replace("Notele mele de credit", "Moja odobrenja")
        );
        $('.client-center-box a[href="/centru-clienti/note-de-livrare-client/"]').text((i, t) => t
            .replace("Notele mele de livrare", "Moje otpremnice")
        );
        $('.client-center-box a[href="/centru-clienti/dovezi-de-plata/"]').text((i, t) => t
            .replace("Dovada mea de plată primită", "Moja potvrda o uplati")
        );
        $('.client-center-box a[href="/centru-clienti/reducerile-mele/"]').text((i, t) => t
            .replace("Reducerile mele", "Moji popusti")
        );
        $('.client-center-box a[href="/centru-clienti/evaluare/"]').text((i, t) => t
            .replace("Evaluările produselor mele", "Moje recenzije proizvoda")
        );
        $('.client-center-box a[href="/centru-clienti/discutiile-mele-despre-produse/"]').text((i, t) => t
            .replace("Discuţiiile mele legate de produse", "Moje rasprave o proizvodima")
        );
    }

    function able_trans_client_setting() {

        able_trans_sidebar();
        $('head title').text((i, t) => t.replace("Configurarea contului meu", "Moje postavke računa"));
        $('#content h1').text((i, t) => t.replace("Configurarea contului meu", "Moje postavke računa"));
        $('.breadcrumbs [itemprop="item"] [itemprop="name"]').each(function (i, el) {
            $(el).text((i, t) => t.replace("Dom", "Početna"));
        });
        $('.breadcrumbs [data-testid="breadcrumbsLastLevel"] [itemprop="name"]').text((i, t) => t.replace("Centru clienți", "Centar za korisnike"));
        $('.breadcrumbs [data-testid="breadcrumbsLastLevel"] [data-title]').attr('data-title', (i, t) => t && t.replace("Centru clienți", "Centar za korisnike"));

        able_trans_registration_inputs();
        $('#content label[for="billFullName"] .required-asterisk').text((i, t) => t.replace("Nume complet", "Ime i prezime"));
        $('#content .phone-form-group .required-asterisk').text((i, t) => t.replace("Telefon", "Telefon"));
        $('#content label[for="email"] .required-asterisk').text((i, t) => t.replace("Email", "Email"));
        $('#content label[for="currentPassword"] .required-asterisk').text((i, t) => t.replace("Parola dvs. curentă pentru a aproba modificările", "Vaša trenutna lozinka za potvrdu promjena"));
        $('#content label[for="password"]').html((i, t) => t.replace("Lozinka nouă", "Nova lozinka").replace("New password", "Nova lozinka"));
        $('#content label[for="passwordAgain"]').html((i, t) => t.replace("Parolă nouă din nou", "Nova lozinka (provjeri)").replace("Introduceţi din nou parola", "Nova lozinka (provjeri)"));
        $('#content label[for="company-shopping"]').text("Kupujem za tvrtku");
        $('#content label[for="companyId"]').text((i, t) => t.replace("Cod fiscal", "Porezni broj"));
        $('#content label[for="vatId"]').text((i, t) => t.replace("Nr. TVA UE", "PDV ID (EU)"));
        $('#vatId').attr('placeholder', (i, v) => (v || "").replace("RO12345678", "HR12345678901"));
        $('#vatId-description').text((i, t) => t.replace("CUI cu RO daca sunteti platitor de TVA", "PDV ID s prefiksom HR ako ste obveznik PDV-a"));
        $('.form-group-tooltip[aria-hidden="true"]').attr('data-original-title', (i, t) =>
            (t || "").replace("CUI cu RO daca sunteti platitor de TVA", "PDV ID s prefiksom HR ako ste obveznik PDV-a")
        );
        $('#content label[for="billCompany"]').text((i, t) => t.replace("Numele companiei", "Naziv tvrtke"));
        $('#content label[for="billStreet"] .required-asterisk').text((i, t) => t.replace("Str., Nr., Bl., Sc., Ap.", "Ulica i broj"));
        $('#content label[for="billCity"] .required-asterisk').text((i, t) => t.replace("Grad", "Grad"));
        $('#content label[for="billZip"] .required-asterisk').text((i, t) => t.replace("Poštanski broj", "Poštanski broj"));
        $('#content label[for="billCountryId"] .required-asterisk').text((i, t) => t.replace("Zemlja", "Zemlja"));
        $('.co-registration .box h4').each(function (i, el) {
            $(el).text((i, t) => t.replace("Adrese de expediere", "Adrese za dostavu"));
        });
        $('.co-registration .box p').each(function (i, el) {
            $(el).html((i, t) => t
                .replace("Nu s-au găsit înregistrări...", "Nema pronađenih zapisa...")
                .replace("Adăugare adresă nouă", "Dodaj novu adresu")
            );
        });
        $('a[href="/centru-clienti/informatii-de-livrare/"]')
            .attr('title', (i, t) => (t || "").replace("Adăugare adresă nouă", "Dodaj novu adresu"))
            .html((i, t) => t.replace("Adăugare adresă nouă", "Dodaj novu adresu"));
        $('.stay-in-touch h4').text((i, t) => t.replace("Păstrăm legătura", "Ostanimo u kontaktu"));
        $('label[for="sendNewsletter"]').html((i, t) => t.replace("Nu doresc să primesc noutăți pe e-mail", "Ne želim primati novosti e-poštom"));
        $('#content div.submit-wrapper input[type="submit"]').attr("value", "Nametnuti");

    }

    function able_trans_client_add_address() {
        able_trans_sidebar();
        $('head title').text((i, t) => t.replace("Shipping address", "Informacije o dostavi"));
        $('#content h1').text((i, t) => t.replace("Shipping address", "Informacije o dostavi"));
        $('.breadcrumbs #navigation-1').html((i, t) => t.replaceAll("Client center", "Centar za klijente"));
        $('.breadcrumbs #navigation-2').text((i, t) => t.replaceAll("Shipping address", "Informacije o dostavi"));

        $('#content h4').html((i, t) => t.replace("Shipping address", "Poštanska adresa"));
        $('#content label[for="deliveryFullName"]').html((i, t) => t.replace("Nume complet", "Ime i prezime"));
        $('#content label[for="deliveryCompany"]').html((i, t) => t.replace("Company", "Naziv tvrtke"));
        $('#content label[for="deliveryStreet"]').html((i, t) => t.replace("Street", "Ulica i kućni broj"));
        $('#content label[for="deliveryCity"]').html((i, t) => t.replace("Localitate", "Grad"));
        $('#content label[for="deliveryZip"]').html((i, t) => t.replace("Cod poştal", "Poštanski broj"));
        $('#content label[for="deliveryCountryId"]').html((i, t) => t.replace("Ţară", "Zemlja"));
        $('#content div.submit-wrapper input[type="submit"]').attr("value", "Nametnuti");
    }

    function able_trans_search_page() {
        $('head title').text((i, t) => t.replace("Căutare", "Pretraživanje"));
        $('.breadcrumbs #navigation-1 [itemprop="name"], .breadcrumbs #navigation-1 [data-title="Căutare"]')
            .each(function () {
                $(this).text($(this).text().replace("Căutare", "Pretraga"));
            });
        $('.js-skip-link--start').text(function (i, t) {
            return t.replace("Sari peste categorii", "Preskoči kategorije");
        });
        $('.js-skip-link--end').text(function (i, t) {
            return t.replace("Sari peste categorii", "Preskoči kategorije");
        });
        $('.box-onlinePayments h4 span').text(function (i, t) {
            return t.replace("Acceptăm plăţi online", "Prihvaćamo online plaćanja");
        });
        $('.box-topProducts h4 span').text(function (i, t) {
            return t.replace("Top 10 produse", "Top 10 proizvoda");
        });
        $('#content h2').html(function (i, html) {
            return html.replace("Rezultatele căutării", "Rezultati pretrage");
        });
        $('.search-results h4[data-testid="searchMsg"]').text(function (i, t) {
            return t.replace("Nu s-au găsit produse", "Nema pronađenih proizvoda");
        });
        $('.searchWhisperer__content--empty[data-testid="searchMsgWhisperer"]').text(function (i, t) {
            return t.replace("Nu s-au găsit rezultate.", "Nema rezultata.");
        });
        $('#formSearchForm input[type="search"]').attr('aria-label', 'Pretraga');
        $('#search-group-categories > h4').text(function (_i, t) {
            return t.replace("Categorii", "Kategorije");
        });
        $('#search-group-categories .display-results-group').text(function (_i, t) {
            return t.replace(/^Afi[şș]are toate/, "Prikaži sve");
        });
        $('#search-group-manufacturers [data-testid="brandsText"]').text(function (_i, t) {
            return t.replace("Branduri", "Brandovi");
        });
        $('#search-group-articles > h4').text(function (_i, t) {
            return t.replace("Articole", "Članci");
        });
        $('#productsListHeading').text(function (_i, t) {
            return t.replace("Produse", "Proizvodi");
        });
    }


    function able_trans_client_dashboard() {
        able_trans_sidebar();

        $('.breadcrumbs [itemprop="item"] [itemprop="name"]').each(function (i, el) {
            $(el).text((i, t) => t
                .replace("Dom", "Početna")
            );
        });
        $('.breadcrumbs [data-testid="breadcrumbsLastLevel"] [itemprop="name"]').html((i, t) => t
            .replace("Centru clienți", "Centar za korisnike")
        );
        $('.breadcrumbs [data-testid="breadcrumbsLastLevel"] [data-title]').attr('data-title', (i, t) => t
            .replace("Centru clienți", "Centar za korisnike")
        );
        $('#content h1').text((i, t) => t
            .replace("Centru clienți", "Centar za korisnike")
        );
        $('#content .content-inner p').html((i, t) => t
            .replace("Nu aveţi nicio comandă rezervată...", "Nemate nijednu rezerviranu narudžbu...")
        );
    }

    function able_trans_client_orders() {
        able_trans_sidebar();

        $('head title').text((i, t) =>
            t.replace(/My orders|Comenzile mele/i, 'Moje narudžbe')
        );
        $('#content h1').text((i, t) =>
            t.replace(/My orders|Comenzile mele/i, 'Moje narudžbe')
        );
        $('.client-link').each(function () {
            const $wrap = $(this);
            $wrap.html((i, html) =>
                html
                    .replace(
                        /Putem asocia comenzile anonime \((\d+)\) cu adresa de e-mail ([^ ]+@[^ ]+) la contul dumneavoastră/,
                        'Možemo povezati anonimne narudžbe ($1) s adresom e-pošte $2 na vaš račun'
                    )
            );
            $wrap.find('a').each(function () {
                $(this).text((i, t) =>
                    t
                        .replace(/dacă vă verificaţi căsuţa de e-mail/i, 'ako potvrdite svoju e-poštu')
                        .replace(/dacă vă verificați căsuța de e-mail/i, 'ako potvrdite svoju e-poštu')
                );
            });
        });
        $('#content').html((i, t) =>
            t
                .replace(/You have no reserved order\.\.\./i, 'Nemate rezerviranu narudžbu...')
                .replace(/Nu aveţi nicio comandă rezervată\.\.\./i, 'Nemate rezerviranu narudžbu...')
                .replace(/Nu aveți nicio comandă rezervată\.\.\./i, 'Nemate rezerviranu narudžbu...')
        );
        $('.breadcrumbs [itemprop="itemListElement"] [itemprop="name"]').each(function () {
            $(this).text((i, t) =>
                t
                    .replace(/Client center|Centru clienți/i, 'Centar za klijente')
                    .replace(/^Dom$/, 'Početna')
            );
        });
        $('.breadcrumbs [data-testid="breadcrumbsLastLevel"] [itemprop="name"]')
            .text((i, t) => t.replace(/My orders|Comenzile mele/i, 'Moje narudžbe'))
            .attr('data-title', (i, t) => (t || '').replace(/My orders|Comenzile mele/i, 'Moje narudžbe'));
    }

    function able_trans_client_payments() {
        able_trans_sidebar();

        $('head title').text((i, t) =>
            t.replace(/Plățile mele|Platile mele/, 'Moja plaćanja')
        );
        $('#content h1').text((i, t) =>
            t.replace(/Plățile mele|Platile mele/, 'Moja plaćanja')
        );
        $('#content').html((i, html) =>
            html
                .replace(/Cărți memorate|Carduri memorate|Carduri salvate/g, 'Spremljene kartice')
                .replace(/Nu există elemente|Nu exista elemente|Nu există articole|Nu sunt elemente|Nu s-au găsit înregistrări|Nu s-au gasit inregistrari/g, 'Nema stavki')
        );
        $('.breadcrumbs [itemprop="itemListElement"] [itemprop="name"]').each(function () {
            $(this).text((i, t) =>
                t
                    .replace(/Centru clienți|Centru clienti/, 'Centar za klijente')
                    .replace(/^Dom$/, 'Početna')
            );
        });
        $('.breadcrumbs [data-testid="breadcrumbsLastLevel"] [itemprop="name"]')
            .text((i, t) => t.replace(/Plățile mele|Platile mele/, 'Moja plaćanja'))
            .attr('data-title', (i, t) => (t || '').replace(/Plățile mele|Platile mele/, 'Moja plaćanja'));
    }

    function able_trans_client_documents() {
        able_trans_sidebar();

        $('head title').text((i, t) =>
            t.replace(/Dovada plății primite|Dovada platii primite/, 'Porezni dokumenti za primljenu uplatu')
        );
        $('#content h1').text((i, t) =>
            t.replace(/Dovada plății primite|Dovada platii primite/, 'Porezni dokumenti za primljenu uplatu')
        );
        $('#content').html((i, html) =>
            html.replace(/Nu aveţi încă documente salvate\.?|Nu aveti inca documente salvate\.?/g,
                'Za vas još nije izrađen nijedan dokument.')
        );
        $('.breadcrumbs [itemprop="itemListElement"] [itemprop="name"]').each(function () {
            $(this).text((i, t) =>
                t
                    .replace(/Centru clienți|Centru clienti/, 'Centar za klijente')
                    .replace(/^Dom$/, 'Početna')
            );
        });
        $('.breadcrumbs [data-testid="breadcrumbsLastLevel"] [itemprop="name"]')
            .text((i, t) =>
                t.replace(/Dovada plății primite|Dovada platii primite/, 'Porezni dokumenti za primljenu uplatu')
            )
            .attr('data-title', (i, t) =>
                (t || '').replace(/Dovada plății primite|Dovada platii primite/, 'Porezni dokumenti za primljenu uplatu')
            );
    }

    function able_trans_client_discussions() {
        able_trans_sidebar();

        $('head title').text((i, t) =>
            t.replace(/Discuțiile mele despre produse|Discutiile mele despre produse/g, 'Rasprava o mojim proizvodima')
        );
        $('#content h1').text((i, t) =>
            t.replace(/Discuțiile mele despre produse|Discutiile mele despre produse/g, 'Rasprava o mojim proizvodima')
        );
        $('#content').html((i, html) =>
            html.replace(/Nu s-au găsit comentarii\.{3}|Nu s-au gasit comentarii\.{3}|Nu s au găsit comentarii\.{3}/g,
                'Nije pronađen nijedan komentar...')
        );
        $('.breadcrumbs [itemprop="itemListElement"] [itemprop="name"]').each(function () {
            $(this).text((i, t) =>
                t
                    .replace(/^Dom$/, 'Početna')
                    .replace(/Centru clienți|Centru clienti/g, 'Centar za klijente')
            );
        });
        $('.breadcrumbs [data-testid="breadcrumbsLastLevel"] [itemprop="name"]').text((i, t) =>
            t.replace(/Discuțiile mele despre produse|Discutiile mele despre produse/g, 'Rasprava o mojim proizvodima')
        );
    }

    function able_trans_client_proform_invoices() {
        able_trans_sidebar();

        $('head title').text((i, t) =>
            t.replace(/Facturi proforma client/g, 'Predračuni')
        );
        $('#content h1').text((i, t) =>
            t.replace(/Facturi proforma client/g, 'Predračuni')
        );
        $('#content').html((i, html) =>
            html.replace(/Nu aveţi încă documente salvate\.|Nu aveți încă documente salvate\./g,
                'Za vas još nije izrađen nijedan dokument.')
        );
        $('.breadcrumbs #navigation-1 [itemprop="name"]').text((i, t) =>
            t.replace(/Centru clienți|Centru clienti/g, 'Centar za klijente')
        );
        $('.breadcrumbs #navigation-2 [itemprop="name"]').text((i, t) =>
            t.replace(/Facturi proforma client/g, 'Predračuni')
        );
    }

    function able_trans_client_credit_notes() {
        able_trans_sidebar();

        $('head title').text((i, t) =>
            t.replace(/Note de credit client/g, 'Kreditne note')
        );
        $('#content h1').text((i, t) =>
            t.replace(/Note de credit client/g, 'Kreditne note')
        );
        $('#content').html((i, html) =>
            html.replace(/Nu aveţi încă documente salvate\.|Nu aveți încă documente salvate\./g,
                'Za vas još nije izrađen nijedan dokument.')
        );
        $('.breadcrumbs #navigation-1 [itemprop="name"]').text((i, t) =>
            t.replace(/Centru clienți|Centru clienti/g, 'Centar za klijente')
        );
        $('.breadcrumbs #navigation-2 [itemprop="name"]').text((i, t) =>
            t.replace(/Note de credit client/g, 'Kreditne note')
        );
    }

    function able_trans_client_delivery_notes() {
        able_trans_sidebar();

        $('head title').text((i, t) =>
            t.replace(/Note de livrare client/g, 'Otpremnice')
        );
        $('#content h1').text((i, t) =>
            t.replace(/Note de livrare client/g, 'Otpremnice')
        );
        $('#content').html((i, html) =>
            html.replace(/Nu aveţi încă documente salvate\.|Nu aveți încă documente salvate\./g,
                'Za vas još nije izrađen nijedan dokument.')
        );
        $('.breadcrumbs #navigation-1 [itemprop="name"]').text((i, t) =>
            t.replace(/Centru clienți|Centru clienti/g, 'Centar za klijente')
        );
        $('.breadcrumbs #navigation-2 [itemprop="name"]').text((i, t) =>
            t.replace(/Note de livrare client/g, 'Otpremnice')
        );
    }


    function able_trans_client_tax_documents() {
        able_trans_sidebar();

        $('head title').text((i, t) =>
            t.replace(/Documente fiscale/g, 'Porezni dokumenti')
        );
        $('#content h1').text((i, t) =>
            t.replace(/Documente fiscale/g, 'Porezni dokumenti')
        );
        $('#content').html((i, html) =>
            html.replace(/Nu aveţi încă documente salvate\.|Nu aveți încă documente salvate\./g,
                'Za vas još nije izrađen nijedan dokument.')
        );
        $('.breadcrumbs [itemprop="itemListElement"] [itemprop="name"]').each(function () {
            $(this).text((i, t) =>
                t
                    .replace(/^Dom$/, 'Početna')
                    .replace(/Centru clienți|Centru clienti/g, 'Centar za klijente')
            );
        });
        $('.breadcrumbs [data-testid="breadcrumbsLastLevel"] [itemprop="name"]').text((i, t) =>
            t.replace(/Documente fiscale/g, 'Porezni dokumenti')
        );
    }

    function able_trans_client_discounts() {
        able_trans_sidebar();

        $('head title').text((i, t) =>
            t.replace(/Reducerile mele/, 'Moji popusti')
        );
        $('#content h1').text((i, t) =>
            t.replace(/Reducerile mele/, 'Moji popusti')
        );
        $('#content').html((i, html) =>
            html
                .replace(/Grup de clienți|Grup de clienti/g, 'Grupa kupaca')
                .replace(/Reducere de fidelitate/g, 'Popust za vjernost')
                .replace(/Reducere suplimentară|Reducere suplimentara/g, 'Dodatni popust')
                .replace(/Reducere curentă pentru client|Reducere curenta pentru client/g, 'Trenutni popust za kupce')
                .replace(
                    /Reducerea finală poate varia în funcţie de setarea respectivelor reduceri la anumite produse\.?|Reducerea finala poate varia in functie de setarea respectivelor reduceri la anumite produse\.?/g,
                    'Konačni iznos popusta može varirati ovisno o postavkama popusta na pojedinim proizvodima.'
                )
        );
        $('.breadcrumbs [itemprop="itemListElement"] [itemprop="name"]').each(function () {
            $(this).text((i, t) =>
                t
                    .replace(/^Dom$/, 'Početna')
                    .replace(/Centru clienți|Centru clienti/, 'Centar za klijente')
            );
        });
        $('.breadcrumbs [data-testid="breadcrumbsLastLevel"] [itemprop="name"]').text((i, t) =>
            t.replace(/Reducerile mele/, 'Moji popusti')
        );
    }

    function able_trans_client_ratings() {
        able_trans_sidebar();

        $('head title').text((i, t) =>
            t.replace(/Evaluările mele privind produsele|Evaluarile mele privind produsele|Evaluările produselor mele|My product ratings/gi, 'Moje ocjene proizvoda')
        );
        $('#content h1').text((i, t) =>
            t.replace(/Evaluările mele privind produsele|Evaluarile mele privind produsele|Evaluările produselor mele|My product ratings/gi, 'Moje ocjene proizvoda')
        );
        $('#content').html((i, html) =>
            html.replace(/Nu s-au găsit evaluări\.|Nu s-au gasit evaluari\.|No ratings found\./gi, 'Nije pronađena nijedna ocjena.')
        );
        $('.breadcrumbs #navigation-1 [itemprop="name"]').text((i, t) =>
            t.replace(/Centru clienți|Centru clienti|Client center/gi, 'Centar za klijente')
        );
        $('.breadcrumbs #navigation-2 [itemprop="name"]').text((i, t) =>
            t.replace(/Evaluările mele privind produsele|Evaluarile mele privind produsele|Evaluările produselor mele|My product ratings/gi, 'Moje ocjene proizvoda')
        );
    }

    function able_trans_login_page() {
        $('#content h1, head title').text((i, t) => t.replace("Autentificare", "Prijaviti se"));
        $('.breadcrumbs #navigation-1').html((i, t) => t.replaceAll("Autentificare", "Prijaviti se"));
        $('#formLogin input[name="email"]').attr("placeholder", "E-mailová adresa (např. jan@novak.cz)");
        $('#formLogin input[name="password"]').attr("placeholder", "Lozinka");
        $('#customerLogin a[href="/inregistrare/"]').html((i, t) => t.replace("Înregistrare nouă", "Nova registracija"));
        $('#customerLogin a[href="/centru-clienti/resetati-parola/"]').html((i, t) => t.replace("Parola uitată", "Zaboravljena lozinka"));
        $('#formLogin button.btn-login').html((i, t) => t.replace("Autentificare", "Prijaviti se"));

    }


    changeMessages()
    able_trans_category()
    able_trans_cartwidget()


    let body = $('body');

    if (body.hasClass("id--7")) {
        able_trans_forgot_password();
    }

    if (body.hasClass("id--4")) {
        able_trans_login_page();
    }
    if (body.hasClass("id--8")) {
        able_trans_registration();
    }
    if (body.hasClass("id--9")) {
        able_trans_cart1();
    }

    if (body.hasClass("id--11")) {
        able_trans_search_page()
    }
    if (body.hasClass("id--12")) {
        able_trans_client_dashboard();
    }
    if (body.hasClass("id--13")) {
        able_trans_client_setting();
    }
    if (body.hasClass("id--18")) {
        able_trans_client_orders();
    }
    if (body.hasClass("id--24")) {
        able_trans_brands_index()
    }
    if (body.hasClass("id--57")) {
        able_trans_client_payments();
    }
    if (body.hasClass("id--64")) {
        able_trans_client_documents();
    }
    if (body.hasClass("id--43")) {
        able_trans_client_tax_documents();
    }
    if (body.hasClass("id--44")) {
        able_trans_client_discounts();
    }
    if (body.hasClass("id--45")) {
        able_trans_client_ratings();
    }
    if (body.hasClass("id--46")) {
        able_trans_client_discussions();
    }
    if (body.hasClass("id--61")) {
        able_trans_client_proform_invoices();
    }
    if (body.hasClass("id--62")) {
        able_trans_client_credit_notes();
    }
    if (body.hasClass("id--63")) {
        able_trans_client_delivery_notes();
    }
    if (body.hasClass("id--25")) {
        able_trans_client_add_address();
    }
    if (body.hasClass("id--15")) {
        able_trans_cart_thanks();
    }
    if (body.hasClass("id--16")) {
        able_trans_cart2();
    }
    if (body.hasClass("id--17")) {
        able_trans_cart3();
    }
    if (body.hasClass("id-29")) {
        able_trans_contact_form()
    }
    if (body.hasClass("id--3")) {
        able_trans_404()
    }
    if (body.hasClass("type-detail")) {
        able_trans_product();
    }


    document.addEventListener("ShoptetDOMPageContentLoaded", function () {
        able_trans_category();
    });

    document.addEventListener("ShoptetDOMPageMoreProductsLoaded", function () {
        able_trans_category();
    });
    document.addEventListener("ShoptetDOMAdvancedOrderLoaded", function () {
        able_trans_category();
        able_trans_advancedOrder()
    });

    document.addEventListener("ShoptetCartUpdated", function () {
        able_trans_cartwidget();
        able_trans_cart1();
    });

    document.addEventListener("ShoptetDOMCartContentLoaded", function () {
        able_trans_cartwidget();
    });
    document.addEventListener("ShoptetDOMContentLoaded", function () {
        able_trans_cookies();
    });


    document.addEventListener("ShoptetShippingMethodUpdated", function () {
        able_trans_cart_summary();
    });
    document.addEventListener("ShoptetBillingMethodUpdated", function () {
        able_trans_cart_summary();
    });

    $(document).ready(function () {

        able_trans_cookies()

        //Překlad notifikací
        const observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
                if (mutation.type === 'childList') {
                    for (const addedNode of mutation.addedNodes) {
                        if (addedNode.nodeName === 'DIV') {
                            able_trans_notification()
                        }
                    }
                }
            }
        });

        observer.observe($('.messages')[0], {childList: true, filters: [{type: 'childList', addedNodes: true}]});

    })

}